import {
    Button,
    Flex,
} from '@chakra-ui/react';
import Card from "components/Card/Card.js";
import { useState } from 'react';
import TranscriptsView4 from './guia_busca_avancada';
import TranscriptsView3 from './guia_interagir';
import TranscriptsView2 from './guia_transcript';

const TranscriptsView = () => {
  const [activeTab, setActiveTab] = useState('tab1');
  const [constID, setConstID] = useState('tab1');

  const openTab = (tabId, idtranscripts) => {
    setActiveTab(tabId);
    setConstID(idtranscripts)
  };
  return (
    <Flex direction="column" overflowY="auto" width="100%">
      <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
        <Flex width="100%">
          <Button flex="1" colorScheme='blue' onClick={() => openTab('tab1')} marginRight="2">Transcrições</Button>
          <Button flex="1" colorScheme='blue' onClick={() => openTab('tab2')} marginRight="2">Interagir</Button>
          <Button flex="1" colorScheme='blue' onClick={() => openTab('tab3')}>Busca avançada</Button>
        </Flex>
        <div style={{ display: activeTab === 'tab1' ? 'block' : 'none' }}>
          <TranscriptsView2 openTab={openTab} />
        </div>
        <div style={{ display: activeTab === 'tab2' ? 'block' : 'none' }}>
          <TranscriptsView3 idtranscripts={constID} />
        </div>
        <div style={{ display: activeTab === 'tab3' ? 'block' : 'none' }}>
          <TranscriptsView4 />
        </div>
      </Card>
    </Flex>
  );
};

export default TranscriptsView;
